//外协算税
import { $http, buildHeaders } from "./index";

//获取外协算税列表
export const calctaxoutsource_list = (params) => {
  return $http.get("/admin/CalcTaxOutsource/index", { params });
};

//获取外协算税详情
export const calctaxoutsource_detail = (id) => {
  return $http.get("/admin/CalcTaxOutsource/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取外协算税工资表明细
export const calctaxoutsource_records = (params) => {
  return $http.get("/admin/CalcTaxOutsource/detail", {
    params,
  });
};

//取消算税
export const calctaxoutsource_cancel = (id) => {
  return $http.post(
    "/admin/CalcTaxOutsource/cancel",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//算税完成
export const calctaxoutsource_complete = (id) => {
  return $http.post(
    "/admin/CalcTaxOutsource/complete",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//保存算税信息
export const calctaxoutsource_save = (data) => {
  return $http.post("/admin/CalcTaxOutsource/save", data, {
    headers: buildHeaders(3),
  });
};

//标记失败
export const calctaxoutsource_setfailure = (data) => {
  return $http.post("/admin/CalcTaxOutsource/setFailure", data, {
    headers: buildHeaders(3),
  });
};

//标记已算税
export const calctaxoutsource_setDone = (data) => {
  return $http.post("/admin/CalcTaxOutsource/setDone", data, {
    headers: buildHeaders(3),
  });
};

//导入算税单
export const calctaxoutsource_import = (data) => {
  let headers = buildHeaders(1, "算税单数据解析中，请稍后……");
  headers["Content-Type"] = "multipart/form-data";
  return $http.post("/admin/CalcTaxOutsource/import", data, {
    headers,
  });
};

//下载工资表模板
export const calctaxoutsource_download = (id) => {
  return $http.get("/admin/CalcTaxOutsource/downloadTemplate", {
    params: { id },
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
